export enum ProviderTypes {
    DMEPOSProvider = 1,
    OrderingProvider = 2
}